import React from 'react';
import "../../styles/all.css"
import "../../styles/theme.css"
import "./leadbox.css"
import Tracking from '../tracking/track';
import Table from "../table/table"
import Events from '../events/event';

function Leadboxes(){
    return(
        <>
        <div className="leadboxes">
           <div className="row">

  <div className="col-md-4">
    <div className="box">
      <div className="number">
        <h4>
          <i className="fa-solid fa-users me-2"></i>
          Total Inquery
        </h4>
        <h5>32K</h5>
      </div>
      <div className="green">
        <h4>20.36%</h4>
      </div>
    </div>
  </div>

  <div className="col-md-4">
    <div className="box">
      <div className="number">
        <h4>
          <i className="fa-solid fa-chart-line me-2"></i>
          Performance
        </h4>
        <h5>45.68%</h5>
      </div>
      <div className="green">
        <h4>10.46%</h4>
      </div>
    </div>
  </div>

  <div className="col-md-4">
    <div className="box">
      <div className="number">
        <h4>
          <i className="fa-solid fa-triangle-exclamation me-2"></i>
          Escaltions
        </h4>
        <h5>985</h5>
      </div>
      <div className="green">
        <h4>25.46%</h4>
      </div>
    </div>
  </div>

  <div className="col-md-4">
    <div className="box">
      <div className="number">
        <h4>
          <i className="fa-solid fa-clock me-2"></i>
          Avg Time
        </h4>
        <h5>0.3,45</h5>
      </div>
      <div className="green">
        <h4>25.46%</h4>
      </div>
    </div>
  </div>

  <div className="col-md-4">
    <div className="box">
      <div className="number">
        <h4>
          <i className="fa-solid fa-check-double me-2"></i>
          Avg Fulfilments
        </h4>
        <h5>0.3,45</h5>
      </div>
      <div className="green">
        <h4>25.46%</h4>
      </div>
    </div>
  </div>

  <div className="col-md-4">
    <div className="box">
      <div className="number">
        <h4>
        <i className="fa-solid fa-rotate me-2"></i>
          Sla Ccompilant
        </h4>
        <h5>0.3,45</h5>
      </div>
      <div className="green">
        <h4>25.46%</h4>
      </div>
    </div>
  </div>
  <div className="col-md-4">
  <div className="box">
    <div className="number">
      <h4>
        <i className="fa-solid fa-headset me-2"></i>
        Support Tickets
      </h4>
      <h5>1,245</h5>
    </div>
    <div className="green">
      <h4>18.20%</h4>
    </div>
  </div>
</div>

<div className="col-md-4">
  <div className="box">
    <div className="number">
      <h4>
        <i className="fa-solid fa-thumbs-up me-2"></i>
        Customer Satisfaction
      </h4>
      <h5>92%</h5>
    </div>
    <div className="green">
      <h4>5.80%</h4>
    </div>
  </div>
</div>

<div className="col-md-4">
  <div className="box">
    <div className="number">
      <h4>
        <i className="fa-solid fa-rotate me-2"></i>
        Resolution Rate
      </h4>
      <h5>87%</h5>
    </div>
    <div className="green">
      <h4>12.40%</h4>
    </div>
  </div>
</div>


</div>

           
        </div>
        <Tracking/>
        <Table/>
<Events/>
        </>
    )
}
export default Leadboxes